import type { SVGProps } from "react";
export function Deezer(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      data-slot="icon"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="m12.1241 3.1362c.1133-.75072.2797-1.22263.4641-1.22364h.0004c.3437.00151.622 1.63858.622 3.65983 0 2.02124-.2788 3.65982-.6229 3.65982-.1411 0-.2708-.27831-.3758-.74467-.1655 1.70666-.5091 2.87986-.9066 2.87986-.3075 0-.5837-.7048-.7689-1.81605-.1267 2.11355-.4452 3.61345-.81751 3.61345-.23381 0-.44689-.5944-.60438-1.5619-.1897 1.9975-.62776 3.3971-1.13862 3.3971s-.94981-1.3991-1.13862-3.3971c-.15661.9675-.36969 1.5619-.60439 1.5619-.37233 0-.68996-1.4994-.81746-3.61345-.18528 1.11125-.46056 1.81605-.76893 1.81605-.39704 0-.74114-1.1727-.90657-2.87986-.10412.46737-.2347.74416-.37587.74416-.34366 0-.62291-1.63857-.62291-3.65982s.27881-3.65982.62291-3.65982c.1844 0 .34984.47342.4641 1.22363.18352-1.29422.4813-2.13569.81834-2.13569.40013 0 .74643 1.18986.91054 2.91767.16058-1.25741.40366-2.05906.67629-2.05906.38205 0 .70674 1.57657.82717 3.77629.22631-1.12784.55365-1.8352.91628-1.8352s.68997.70786.91584 1.8352c.12087-2.19922.44512-3.77629.82716-3.77629.2722 0 .51523.80165.67633 2.05906.1636-1.72781.5104-2.91767.9101-2.91767.3352.0005.6343.84198.8179 2.1362zm-10.27409 2.0762c0-.90348.15793-1.63605.35336-1.63605.19499 0 .35337.73257.35337 1.63605 0 .90349-.15794 1.63606-.35337 1.63606-.19499 0-.35336-.73257-.35336-1.63606zm11.54329 0c0-.90348.1579-1.63605.3533-1.63605.195 0 .3534.73257.3534 1.63605 0 .90349-.1579 1.63606-.3534 1.63606-.1954 0-.3533-.73257-.3533-1.63606z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}
